/* eslint global-require: off */
/* eslint @typescript-eslint/no-var-requires: off */
import { v4 as uuidv4 } from 'uuid';
import * as Auth from '../api/Auth';
import { sopClient } from '../api/Auth';
// disabled in nodejs threads
const hasDOM = typeof window !== 'undefined' && typeof document !== 'undefined';
const debug = process.env.REACT_APP_MODE === 'dev';
const ANONYMOUS_EXTERNAL_ID = 'ANONYMOUS';
let currentExternalId = null;
let pendingEvents = {
    [ANONYMOUS_EXTERNAL_ID]: []
};
addEventListener('beforeunload', sendPendingEvents);
setInterval(sendPendingEvents, 2000);
function sendPendingEvents() {
    if (!(Auth.getSopToken && Auth.getSopToken()) ||
        !currentExternalId ||
        !(pendingEvents[currentExternalId].length || pendingEvents[ANONYMOUS_EXTERNAL_ID].length)) {
        return;
    }
    const externalId = currentExternalId;
    const sendingEvents = [...pendingEvents[ANONYMOUS_EXTERNAL_ID], ...pendingEvents[externalId]].map((event) => ({
        ...event,
        ...{
            payload: {
                ...event.payload,
                ...{
                    installationId,
                    deviceId
                }
            }
        }
    }));
    pendingEvents[externalId] = [];
    pendingEvents[ANONYMOUS_EXTERNAL_ID] = [];
    sopClient.sendAnalyticsEvents(sendingEvents).catch((error) => {
        pendingEvents[externalId] = [...sendingEvents, ...pendingEvents[externalId]];
        console.error(error);
    });
}
let globalProperties = {};
let userProperties = {};
let deviceId;
let installationId;
let licenseId;
const init = (sopalitics) => {
    if (debug) {
        console.log('sopaliticsApi.init()');
    }
    if (!hasDOM) {
        console.log('sopaliticsApi is disabled in context');
        return;
    }
    deviceId = sopalitics?.deviceId || fallbackId();
    installationId = sopalitics?.installationId || fallbackId();
    const userAgent = navigator.userAgent;
    register({
        useragent: userAgent,
        locale: navigator?.language,
        resolution: screen?.width + 'x' + screen?.height,
        viewport: window?.innerWidth + 'x' + window?.innerHeight,
        platform: /android/i.test(userAgent)
            ? 'Android'
            : /iPad|iPhone|iPod/.test(userAgent)
                ? 'iOS'
                : 'Desktop',
        orientation: screen?.orientation?.type
    });
};
const setDeviceIds = (sopalitics) => {
    deviceId = sopalitics?.deviceId || deviceId;
    installationId = sopalitics?.installationId || installationId;
};
const setLicenseId = (_licenseId) => {
    if (typeof _licenseId === 'string') {
        licenseId = parseInt(_licenseId);
    }
    else {
        licenseId = _licenseId;
    }
};
const fallbackId = () => {
    let sid = localStorage.getItem('ref-sid');
    if (!sid) {
        sid = uuidv4();
    }
    localStorage.setItem('ref-sid', sid);
    return sid;
};
const updateTracking = (_track) => {
    // NOP
};
const onLogin = (externalId) => {
    if (debug) {
        console.log('sopaliticsApi.onLogin()', externalId);
    }
    if (!hasDOM) {
        return;
    }
    pendingEvents[externalId] = [...(pendingEvents[externalId] || [])];
    currentExternalId = externalId;
    userProperties = {};
};
const onLogout = () => {
    if (debug) {
        console.log('sopaliticsApi.onLogout()');
    }
    if (!hasDOM) {
        return;
    }
    currentExternalId = null;
    userProperties = {};
};
const event = (name, properties = {}) => {
    if (debug) {
        console.log('sopaliticsApi.event()', currentExternalId || ANONYMOUS_EXTERNAL_ID, name, properties);
    }
    if (!hasDOM) {
        return;
    }
    pendingEvents[currentExternalId || ANONYMOUS_EXTERNAL_ID].push({
        licenseId,
        createdAt: new Date(),
        payload: {
            name,
            installationId,
            deviceId,
            properties: { ...globalProperties, ...userProperties, ...properties }
        }
    });
};
const register = (properties) => {
    if (debug) {
        console.log('sopaliticsApi.register()', properties);
    }
    if (!hasDOM) {
        return;
    }
    globalProperties = { ...globalProperties, ...properties };
};
const setProperties = (properties) => {
    if (debug) {
        console.log('sopaliticsApi.setProperties()', properties);
    }
    if (!hasDOM) {
        return;
    }
    userProperties = { ...userProperties, ...properties };
};
export const sopaliticsApi = {
    init,
    updateTracking,
    onLogin,
    onLogout,
    register,
    event,
    setProperties,
    setDeviceIds,
    setLicenseId
};
//# sourceMappingURL=sopalitics.js.map